import { loadSettingsFromDB } from './sagas'

import actions from './actions'
import { initialState, settingsVersion } from './types'
import type { SettingsState } from './types'

interface Action {
  type: string
  payload?: Record<string, unknown>
}

// NOTE: 여기서는 settingsMigration을 호출하지 않는다.
// 이 함수는 Redux store 생성 직전 초기값만 제공하며, 실제 데이터 마이그레이션은
// 로그인 후 실행되는 RELOAD_SETTINGS saga의 loadWithMigration이 담당한다.
// 그 saga의 SET_STATE가 이 초기 state 전체를 덮어쓰므로 여기서 중복 실행할 필요가 없다.
export async function getInitialState(): Promise<SettingsState> {
  return loadSettingsFromDB(initialState)
}

const initialSetting = await getInitialState()

export default function settingsReducer(
  state: SettingsState = initialSetting,
  action: Action,
): SettingsState {
  switch (action.type) {
    case actions.SET_STATE:
      // redux에 기록될 때는 항상 최신 버전으로 기록되도록 version을 덮어씌움.
      return { ...state, ...action.payload, version: settingsVersion }
    default:
      return state
  }
}
